// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import Close from "@stoneage/XDL/Icons/IconClear";
import { fontConfig } from "@stoneage/XDL/constants";
import { xBaseTheme } from "@stoneage/XDL/types";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        iconProps: {
            src: Close,
            color: "common.white",
            width: 10,
            height: 10,
            css: css`
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;

                &&& {
                    top: 2px;
                }
            `,
        },
        typographyProps: {
            ...fontConfig.xxSmall,
            weight: fontConfig.weight.medium,
            css: css`
                margin: 0;
                letter-spacing: 0;
            `,
        },
        css: css`
            gap: 8px;
            padding: 6px;
            align-items: flex-start;
            min-height: unset;
            max-height: unset;

            border-radius: 2px;
            background-color: ${color("secondary")};
            transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;

            &:hover,
            &:focus {
                background-color: ${color("primary")};
            }

            && button {
                background-color: unset;
                min-height: unset;
                max-width: 10px;
                height: 10px;
                &:hover,
                &:focus {
                    background: transparent;
                    ${IconWrapper} {
                        color: ${color("danger")};
                    }
                }
            }
        `,
    },
} as xBaseTheme["tag"];
